import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { TranslateConstant } from './constants/TranslateConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';
import { resolveCurrentLangCode, resolveUserLangCode } from '../config/currentLang';

// Create/Modify 성공 후 현재 언어의 translate 캐시를 즉시 갱신 (IMP-247).
// Translate.js 의 Map 캐시는 localStorage 'translate' raw 문자열이 바뀔 때 자동 재빌드.
const _refreshTranslateLocalStorage = async () => {
    try {
        const userRaw = localStorage.getItem('user');
        if (!userRaw) return;
        const parsed = JSON.parse(userRaw);
        const lang = resolveUserLangCode(parsed);
        const data = await SearchByLanguageDirect(lang);
        if (Array.isArray(data)) {
            localStorage.setItem('translate', JSON.stringify(data));
        }
    } catch (e) {
        console.warn('[TranslateAction] Failed to refresh translate cache:', e);
    }
};

const Create = (data) => async (dispatch) => {
    try {
        const ret = await axios.post(AppConfig.API_SERVER_PATH + "/translate", {
            type: "regist",
            data,
            who: JSON.parse(localStorage.getItem('user')).adminid
        }, JWT());

        if (ret.data.status == 'success') {
            dispatch({ type: TranslateConstant.REGIST_TRANSLATE_DATA, translate: ret.data.data });
            dispatch(AlertAction.Success(t('common.message.success.saved')));
            await _refreshTranslateLocalStorage();
        } else {
            dispatch(AlertAction.Error(ret.data));
        }
    } catch (e) {
        console.warn('[TranslateAction] Create failed:', e);
        dispatch(AlertAction.Error(e));
    }
}

const Modify = (data) => async (dispatch) => {
    try {
        const adminId = JSON.parse(localStorage.getItem('user')).adminid;
        const ret = await axios.post(AppConfig.API_SERVER_PATH + "/translate", { type: 'modify', data, who: adminId }, JWT());

        if (ret.data.status == 'success') {
            dispatch({ type: TranslateConstant.MODIFY_TRANSLATE_DATA, translate: ret.data.data });
            dispatch(AlertAction.Success(t('common.message.success.saved')));
            await _refreshTranslateLocalStorage();
        } else {
            dispatch(AlertAction.Error(ret.data));
        }
    } catch (e) {
        console.warn('[TranslateAction] Modify failed:', e);
        dispatch(AlertAction.Error(e));
    }
}

const GetAll = (extend) => async (dispatch) => {
    const params = extend !== undefined ? `?extend=${extend}` : '';
    try {
        const ret = await axios.get(AppConfig.API_SERVER_PATH + "/translate" + params, JWT());
        if (ret.data.status == 'success') {
            dispatch({ type: TranslateConstant.GET_TRANSLATE_DATA, translate: ret.data.data });
        } else {
            dispatch(AlertAction.Error(ret.data));
        }
    } catch (e) {
        console.warn('[TranslateAction] GetAll failed:', e);
        dispatch(AlertAction.Error(e.message));
    }
}

const SearchByLanguageDirect = async (language) => {
    const aggregate = [];
	aggregate.push({ '$match' : { isDel: false, language: language } });
	aggregate.push({
		'$project': {
            _id : 0,
			title: 1,
			language: 1,
			contents: 1
		}
	});
	const data = {
		data : {
			type: "translates",
            passfilter: true,
			aggregate,
		}
	}
	const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
    //const ret = await axios.get(AppConfig.API_SERVER_PATH + "/translate/" + language);
    if (ret.data.status == 'success')
        return ret.data.data;
}

const SearchByLanguage = () => async (dispatch) => {
    const language = resolveCurrentLangCode();
    if (!language) {
        console.warn('[TranslateAction.SearchByLanguage] skipped', {
            handler: 'TranslateAction.SearchByLanguage',
            reason: 'current language could not be resolved',
        });
        return;
    }

    const ret = await axios.get(AppConfig.API_SERVER_PATH + "/translate/" + language);
    if (ret.data.status == 'success') {
        dispatch({ type: TranslateConstant.SEARCH_TRANSLATE_DATA, translate: ret.data.data });
    } else {
        dispatch(AlertAction.Error(ret.data));
    }
}

export const TranslateAction = {
    Create,
    Modify,
    GetAll,
    SearchByLanguage,
    SearchByLanguageDirect
};
